<template>
  <div class="w-100">
    <ul class="mobile-list pl-4 mt-3">
      <li
        class=""
        v-for="collection in collections.slice(0, 3)"
        :key="collection.code"
      >
        <a
          class="text-reset text-decoration-none"
          :href="$helpers.getCollectionOverviewUrl(collection.name)"
          v-html="$helpers.matchText(collection.name, searchTerm)"
        />
      </li>
      <li class="" v-for="page in pages.slice(0, 3)" :key="page.code">
        <a
          class="text-reset text-decoration-none"
          :href="page.url"
          v-html="$helpers.matchText(page.title, searchTerm)"
        />
      </li>
    </ul>
    <ul class="mobile-list-menu pl-4 mt-3">
      <li>
        <a
          class="text-reset text-decoration-none"
          :href="`/search?searchTerm=${searchTerm}`"
        >
          {{ $resourceString["site.search.collections.result.header"] }}
        </a>
      </li>
      <li>
        <a
          class="text-reset text-decoration-none"
          :href="`/search?searchTerm=${searchTerm}&tab=styles`"
        >
          {{ $resourceString["site.search.styles.result.header"] }}
        </a>
      </li>
      <li>
        <a
          class="text-reset text-decoration-none"
          :href="`/search?searchTerm=${searchTerm}&tab=page-content`"
        >
          {{ $resourceString["site.search.result.page.content"] }}
        </a>
      </li>
    </ul>
    <div class="mt-5 pl-4 pb-4">
      <a class="see-all-link" :href="`/search?searchTerm=${searchTerm}`">
        <span class="pr-1">{{ $resourceString["site.search.result.see.all"] }}</span>
        <span class="png-icon png-icon-icons-glyph--k-arrow-right-sm" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      searchTerm: "searchMenu/searchTerm",
      collections: "searchMenu/collections",
      pages: "searchMenu/pages",
    }),
  },
};
</script>

<style>
</style>
